import React from "react";
import Header from "src/components/common/Header";
import Sidebar from "src/components/common/Sidebar";
import Footer from "src/components/common/Footer";
import HistoryMain from "src/components/settings/history/HistoryMain";
import { RODEO_PAGE_NAME } from "src/_config";

interface HistoryContainerProps {}

const HistoryContainer: React.FC= () => {
  return (
    <>
      <Header variant="topbar" />
      <Sidebar page={RODEO_PAGE_NAME.SETTINGS_HISTORY} showSettingsSidebar={true} />
      <HistoryMain />
      <Footer variant="dashboard" />
    </>
  );
};

export default HistoryContainer;